var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.6,70.8c-.4.3-1-.2-.8-.6l5.1-13.4c1.3-3-.2-6.3-2.7-7.3-1.3-.5-2.9-.4-4.2.4s-1.8,1.5-2.3,2.5c-5,10-10,20-15.1,29.9-3.8,10.1-.7,21.4,7.4,27.5,4.3,3.3,9.7,4.8,15.1,4.6s7.8-1.5,11.2-3.5c10.7-6.4,21.4-12.7,32.1-19.1,2.2-1.7,2.8-4.6,1.5-6.7-.3-.4-.6-.8-.9-1.1-1.6-1.4-4-1.4-5.8-.3-4.6,3-9.2,6-13.8,8.9-.6.2-1.2,0-1.4-.4-.3-.5,0-1.4.7-1.8,6.7-4,13.3-8,20-11.9s1.9-1.6,2.2-2.7.2-2.4-.4-3.5c0-.2-.2-.3-.3-.5-1.3-1.8-3.9-2.2-5.8-1-6.2,3.8-12.4,7.6-18.5,11.4-.5.1-1,0-1.2-.4-.4-.5-.2-1.3.4-1.7,8.1-4.8,16.3-9.6,24.4-14.5,2.4-1.9,2.7-5.2,1.1-7.1-.9-1.1-2.4-1.6-4-1.5s-1.6.4-2.3.8c-7.9,5-15.8,10.1-23.7,15.1-.7.2-1.4,0-1.7-.6-.3-.6-.2-1.4.5-1.8l21.4-12.8c1.7-1.4,2.3-3.7,1.5-5.5-.8-1.7-2.6-2.8-4.6-2.7s-1.6.4-2.3.8c-11,6.8-21.9,13.6-32.9,20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,0C33.6,0,0,33.6,0,75s33.6,75,75,75,75-33.6,75-75S116.4,0,75,0ZM75.9,136.6c-34,0-61.6-27.6-61.6-61.6S41.9,13.4,75.9,13.4s61.6,27.6,61.6,61.6-27.6,61.6-61.6,61.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "105.7 100.6 104.2 101.4 105.6 100.4 105.7 100.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.8,48.3l5.7-8.6c.8-2.1.4-4.4-.9-5.7-1.9-1.9-5.5-2-7.9.4-7.4,10.6-14.9,21.2-22.3,31.8l-.4-15.5c-.7-2.1-2.4-3.6-4.5-3.9-2.5-.4-5.1,1.2-6.1,3.9l-.8,35.6c.3,1.8,1.6,8.3,7.4,13.2,4.6,3.9,9.5,4.7,11.5,4.9-2.7-4.3-5.9-11.1-4.6-18.6.2-1.3.4-1.4,4.2-10,3.4-7.5,7.8-14.5,11.1-22,.4-1,1.4-3.6,3.8-4.9,1.4-.8,2.9-.8,3.9-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.9,57.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.4,49c.8.4,1.9,1,2.9,2.2,2.2,2.5,2.2,5.5,2.1,6.4,3.8-5,7.6-9.9,11.5-14.9,1.1-2.4.3-5.3-1.8-6.7-1.9-1.3-4.4-1.2-6.3.3-2.8,4.2-5.6,8.5-8.4,12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.5,66.6c-1.1.7-2.5-.6-1.7-1.8,1.7-2.5,3.5-5,5.4-7.6,2.5-3.4,4.9-6.5,7.3-9.6s2.4-2.1,4-2.1,1.9.2,2.6.7c1.3.9,2.1,2.9,1.8,5s-1.5,3.9-3.3,5.1c-5.4,3.4-10.7,6.9-16.1,10.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapIcon);
export default __webpack_public_path__ + "static/media/clap_icon.101ed9aa8866729114947f25f50468e8.svg";
export { ForwardRef as ReactComponent };